<template>
  <div class="shadow-card">
    <div :style="{ display: 'flex', alignItems: 'center' }">
      <div style="position: relative">
        <a-avatar
          :style="{ color: ' #ffffff !important', backgroundColor: medImage ? '' : '#E1EAF7', padding: '10px' }"
          :src="medImage ? medImage : icon"
          :size="70"
          class="text-capitalize fw900 font20"
        >
        </a-avatar>
        <a-avatar
          @click="() => viewProfile('reviewer')"
          :style="{
            color: ' #ffffff !important',
            backgroundColor: review.reviewer[0].url || review.reviewer[0].image ? '' : '#C997C5',
            right: 0,
            bottom: 0,
            borderColor: 'white',
            borderWidth: '1px',
            borderStyle: 'solid',
          }"
          :src="review.reviewer[0].url || review.reviewer[0].image"
          :size="24"
          class="text-capitalize cp fw900 position-absolute font8"
        >
          {{ reviewerName === "by you" ? this.authUser.user.display_name[0] : reviewerName[3] }}
        </a-avatar>
      </div>
      <div :style="{ flex: 1, 'margin-left': '16px' }">
        <p class="text-name d-flex flex-column">
          {{ name }}
          <span class="text-reviewed">
            <i class="fa fa-star-o fa-sm" aria-hidden="true" :style="{ width: '20px' }"> </i>
            has been reviewed
          </span>
        </p>
        <p class="text-day" :style="{ display: 'flex' }" @click="() => viewProfile('reviewer')">
          <span class="text-name-2">{{ reviewerName }} </span>
          {{ time }}
        </p>
      </div>
      <div class="star-cont">
        <div class="str-grp">
          <ReviewStar :rating="review.rating.toFixed(1)" :height="24" :width="24" />
          <p class="review-text">{{ review.rating.toFixed(1) }}</p>
        </div>
        <font-awesome-icon v-if="!expand" @click="expand = !expand" size="2x" style="transform: scale(0.7); width: 24px; height: 24px; color: #94a3b8; cursor: pointer" :icon="['fas', 'angle-down']" />
        <font-awesome-icon v-if="expand" @click="expand = !expand" size="2x" style="transform: scale(0.7); width: 24px; height: 24px; color: #94a3b8; cursor: pointer" :icon="['fas', 'angle-up']" />
      </div>
    </div>
    <a-divider type="horizontal" style="margin: 16px 0px" class="mob" />
    <div class="star-cont-mob">
      <div class="str-grp">
        <ReviewStar :rating="review.rating.toFixed(1)" :height="24" :width="24" />
        <p class="review-text">{{ review.rating.toFixed(1) }}</p>
      </div>
      <font-awesome-icon v-if="!expand" @click="expand = !expand" size="2x" style="transform: scale(0.7); width: 24px; height: 24px; color: #94a3b8; cursor: pointer" :icon="['fas', 'angle-down']" />
      <font-awesome-icon v-if="expand" @click="expand = !expand" size="2x" style="transform: scale(0.7); width: 24px; height: 24px; color: #94a3b8; cursor: pointer" :icon="['fas', 'angle-up']" />
    </div>
    <div v-if="expand">
      <a-divider type="horizontal" style="margin: 16px 0px" class="web" />
      <p
        class="review-description"
        :style="{ marginBottom: description ? (description.length > 150 ? '0px' : '16px') : '0px' }"
        v-html="seeMore ? getLimitedDescription(description) : description"
      ></p>
      <div v-if="description">
        <p style="padding: 16px 0px" v-if="description.length > 150 && seeMore" @click="seeMore = !seeMore">
          <span class="see-more">see more</span>
        </p>
        <!-- <p style="padding: 16px 0px" v-if="description.length > 150 && !seeMore" @click="seeMore = !seeMore">
          <span class="see-more">see less</span>
        </p> -->
      </div>
      <div style="display: flex; row-gap: 16px; column-gap: 8px; flex-wrap: wrap; padding-bottom: 32px">
        <div class="rate-box" v-for="(item, index) in rating_list" v-if="rating_value_list[index]" :key="item">
          {{ item }}
          <ReviewStar :rating="rating_value_list[index]" :height="16" :width="16" />
          <span v-if="rating_value_list[index]" class="rate-value" v-html="getRating(rating_value_list[index])"></span>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: flex-end" v-if="reviewerName !== 'by you'">
        <div class="footer-container">
          <p class="footer-text">Was this review helpful?</p>
          <p>
            <font-awesome-icon v-if="!reaction.like" :icon="['fal', 'thumbs-up']" class="like-button" @click="setReactions('like', review.id)" />
            <font-awesome-icon v-else class="like-button" :icon="['fas', 'thumbs-up']" :style="{ color: getPrimaryColor() }" @click="deleteReaction(like_id, 'like', review.id, 'deleteLike')" />
            <font-awesome-icon v-if="!reaction.dislike" :icon="['fal', 'thumbs-down']" style="margin-left: 20px; cursor: pointer" @click="setReactions('dislike', review.id)" />
            <font-awesome-icon
              v-else
              class="like-button"
              :icon="['fas', 'thumbs-down']"
              :style="{ marginLeft: '20px', color: getPrimaryColor(), cursor: 'pointer' }"
              @click="deleteReaction(dislike_id, 'like', review.id, 'deleteDislike')"
            />
          </p>
        </div>
        <p class="footer-text" style="cursor: pointer" @click="setReactions('flag', review.id)">
          <span>
            <font-awesome-icon v-if="!reaction.flag" :icon="['fal', 'flag']" style="margin-right: 10px" />
            <font-awesome-icon v-else :icon="['fas', 'flag']" :style="{ marginRight: '10px', color: getPrimaryColor() }" />
          </span>
          Flag Review
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core"
import { faFilter, faStar, faFlag, faThumbsDown, faThumbsUp, faAngleDown, faAngleUp } from "@fortawesome/pro-solid-svg-icons"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import ReviewStar from "../../commons/ReviewStar.vue"

const PostRepository = RepositoryFactory.get("posts")
const UserRepository = RepositoryFactory.get("user")
library.add(faFilter, faFlag, faStar, faThumbsDown, faThumbsUp, faAngleDown, faAngleUp)

export default {
  name: "ReviewCard",
  props: { reviewData: Object, isReviewer: { default: false, type: Boolean } },
  components: { ReviewStar },
  data() {
    return {
      icon: require("../../../assets/medrev.svg"),
      review: null,
      image: null,
      name: null,
      title: null,
      reviewType: null,
      rating_list: [
        "accessibility",
        "adherence_by_patients",
        "affordability",
        "availability_of_alternatives",
        "ease_of_use",
        "drug_interactions",
        "effectiveness",
        "tolerability",
        "side_effects",
        "safety",
      ],
      rating_value_list: [],
      expand: false,
      time: "",
      description: null,
      seeMore: true,
      reaction: { flag: false, like: false, dislike: false },
      like_id: null,
      dislike_id: null,
      flag_id: null,
      reviewerName: "",
    }
  },

  created() {
    console.warn("MedReviewCard.vue is created")
    this.review = this.reviewData

    if (!this.isReviewer) {
      switch (this.review.reviewer_role) {
        case "hospital_administrator":
          this.reviewerName = this.authUser.user.display_name.toLowerCase() === this.review.reviewer[0].hospital_name.toLowerCase() ? "by you" : "by " + this.review.reviewer[0].hospital_name
          break
        case "clinic_administrator":
          this.reviewerName = this.authUser.user.display_name.toLowerCase() === this.review.reviewer[0].clinic_name.toLowerCase() ? "by you" : "by " + this.review.reviewer[0].clinic_name
          break
        case "nfp_administrator":
          this.reviewerName = this.authUser.user.display_name.toLowerCase() === this.review.reviewer[0].nfp_name.toLowerCase() ? "by you" : "by " + this.review.reviewer[0].nfp_name
          break
        case "hcp":
          this.reviewerName = this.authUser.user.display_name.toLowerCase() === this.review.reviewer[0].full_name.toLowerCase() ? "by you" : "by " + this.review.reviewer[0].full_name
          break
        case "doctor":
          if (this.authUser.user.display_name.toLowerCase() === this.review.reviewer[0].display_name.toLowerCase()) {
            this.reviewerName = "by you"
          } else {
            this.reviewerName = this.review.reviewer[0].display_name ? this.review.reviewer[0].display_name : this.review.reviewer[0].first_name + " " + this.review.reviewer[0].last_name
            this.reviewerName = this.review.reviewer[0].tiltle ? this.reviewerName + ", " + this.review.reviewer[0].tiltle : this.reviewerName
            this.reviewerName = "by " + this.reviewerName
          }
          break
        default:
          this.reviewerName = this.authUser.user.display_name.toLowerCase() === this.review.reviewer[0].display_name.toLowerCase() ? "by you" : "by " + this.review.reviewer[0].display_name
          break
      }
    } else {
      this.reviewerName = "by you"
    }

    this.reaction.flag = this.review.flag_reaction ? true : false
    this.reaction.like = this.review.like_reaction ? true : false
    this.reaction.dislike = this.review.dislike_reaction ? true : false
    this.flag_id = this.review.flag_reaction ? this.review.flag_reaction[0].id : null
    this.like_id = this.review.like_reaction ? this.review.like_reaction[0].id : null
    this.dislike_id = this.review.dislike_reaction ? this.review.dislike_reaction[0].id : null
    this.time = this.formatPostTime(this.review.created_at)
    this.name = this.review.medication_name
    this.medImage = this.review.medication_details.url

    this.description = this.review.description
    this.rating_value_list.push(
      this.review.accessibility,
      this.review.adherence_by_patients,
      this.review.affordability,
      this.review.availability_of_alternatives,
      this.review.drug_interactions,
      this.review.ease_of_use,
      this.review.effectiveness,
      this.review.safety,
      this.review.tolerability,
      this.review.side_effects
    )
  },
  methods: {
    formatPostTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return "a few seconds ago"
      } else if (seconds <= 90) {
        return "a minute ago"
      } else if (minutes <= 45) {
        return minutes + " minutes ago"
      } else if (minutes <= 90) {
        return "an hour ago"
      } else if (hours <= 22) {
        return hours + " hours ago"
      } else if (hours <= 36) {
        return "a day ago"
      } else if (days <= 25) {
        return days + " days ago"
      } else if (days <= 45) {
        return "a month ago"
      } else if (days <= 345) {
        return months + " months ago"
      } else if (days <= 545) {
        return "a year ago"
      } else {
        // (days > 545)
        return years + " years ago"
      }
    },
    getLimitedDescription(description) {
      const div = document.createElement("div")
      div.innerHTML = description
      const text = div.textContent || div.innerText || ""

      return text.length > 150 ? text.substring(0, 150) + "..." : text
    },
    getRating(rating) {
      return parseFloat(rating).toFixed(1)
    },
    reactReview(rType, revId) {
      const REACTION_TYPES = { flag: 5, like: 2, dislike: 11 }
      const payload = {
        reacted_on_type: 11,
        reacted_on_id: revId,
        user: this.authUser.user.id,
        user_role: this.authUser.user.role || "",
        reaction_type: REACTION_TYPES[rType],
      }

      PostRepository.saveReaction(this.currentCircle.id, payload)
        .then(res => {
          this.reaction[rType] = true
          if (rType === "like") {
            this.like_id = res.data.data.id
          } else if (rType === "dislike") {
            this.dislike_id = res.data.data.id
          } else if (rType === "flag") {
            this.flag_id = res.data.data.id
          }
          this.$notification.success({
            message: "Successful",
            description: `${rType === "like" ? "Helpful" : rType === "dislike" ? "Unhelpful" : "Flag"} has been saved`,
          })
        })
        .catch(err => {
          this.$notification.error({ message: "Error", description: `Cannot ${rType}` })
        })
    },
    deleteReaction(id, rType, revId, deleteType) {
      const user = JSON.parse(localStorage.getItem("user"))
      const headers = {
        Authorization: `Bearer ${user.user.token}`,
      }
      this.$http
        .delete(`${process.env.BASE_API_URL}/reactions/?ids=${id.toString()}`, { headers })
        .then(res => {
          if (deleteType === "deleteLike") {
            this.reaction["like"] = false
            this.$notification.success({ message: "Successful", description: `Helpful has been unsaved` })
          } else if (deleteType === "deleteDislike") {
            this.reaction["dislike"] = false
            this.$notification.success({ message: "Successful", description: `Unhelpful has been unsaved` })
          } else if (deleteType === "flag") {
            this.reaction[deleteType] = false
            this.$notification.success({ message: "Successful", description: `Flag has been unsaved` })
          } else {
            this.reaction[deleteType] = false
          }
          if (deleteType != "flag" && deleteType != "deleteLike" && deleteType != "deleteDislike") {
            this.reactReview(rType, revId)
          }
        })
        .catch(err => {
          this.$notification.error({ message: "Error", description: `Cannot ${rType}` })
        })
    },
    setReactions(rType, revId) {
      if (rType === "dislike") {
        if (this.reaction.like === true) {
          this.deleteReaction(this.like_id, rType, revId, "like")
        } else {
          this.reactReview(rType, revId)
        }
      } else if (rType === "like") {
        if (this.reaction.dislike === true) {
          this.deleteReaction(this.dislike_id, rType, revId, "dislike")
        } else {
          this.reactReview(rType, revId)
        }
      } else if (rType === "flag") {
        if (this.reaction.flag === true) {
          this.deleteReaction(this.flag_id, rType, revId, "flag")
        } else {
          this.reactReview(rType, revId)
        }
      }
    },

    viewProfile(type = "reviewee") {
      const user = this.review
      if (type === "reviewee") {
        if (user.reviewee.hasOwnProperty("is_virtual")) {
          this.routeProfile(type)
        } else {
          this.profile(type)
        }
      } else {
        this.profile(type)
      }
    },
    profile(type = "reviewee") {
      const user = this.review
      if (type === "reviewee") {
        if (user.reviewee.hasOwnProperty("ext_ref_id")) {
          user["user_id"] = user.reviewee.ext_ref_id
        } else {
          user["user_id"] = user.reviewee.id
        }
        user["role"] = user.reviewee_role
      } else {
        user["user_id"] = user.reviewer_id
        user["role"] = user.reviewer_role
      }
      if (user.role === "admin") {
        return
      }
      this.loadingScreen = true
      if (user.user_id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(
          user.reviewee.ext_ref_id && type === "reviewee" ? { ext_ref_id: user.user_id, role: user.role } : { id: user.user_id, role: user.role },
          this.currentCircle.id
        )
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              no_of_members: res.data.data.no_of_members,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
              overall_rating: res.data.data.overall_rating ? res.data.data.overall_rating : res.data.data.rating,
              inPersonReview: res.data.data.in_person_visit,
              onlineReview: res.data.data.online_tele_medicine,
              myCirclesReview: res.data.data.my_circle,
            }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "doctor":
              case "physician":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: user.user_id },
                })
                break
              case "clinic_administrator":
                this.$router.push({
                  name: "ViewClinicAbout",
                  params: { id: user.user_id },
                })
                break
              case "hospital_administrator":
                this.$router.push({
                  name: "ViewHos_adminAbout",
                  params: { id: user.user_id },
                })
                break
              case "nfp":
                this.$router.push({
                  name: "ViewNfpAbout",
                  params: { id: user.user_id },
                })
                break
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.user_id },
                })
                break
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.user_id, role: 'caregiver' },
                })
                break
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateAbout",
                  params: { id: user.user_id },
                })
                break
              case "hospital":
                this.$router.push({
                  name: "HospViewAbout",
                  params: { id: user.user_id },
                })
                break
              case "clinic":
                this.$router.push({
                  name: "ClinicViewAbout",
                  params: { id: user.user_id },
                })
              case "nfp_administrator":
                this.$router.push({
                  name: "ViewNfpAdminAbout",
                  params: { id: user.user_id },
                })
                break
              default:
                break
            }
          })
          .catch(err => {
            this.loadingScreen = false
          })
      }
    },
    routeProfile(type = "reviewee") {
      this.loadingScreen = true
      let info = {}
      if (type === "reviewee") {
        info = this.review.reviewee
        if (!info.hasOwnProperty("role")) {
          info["role"] = this.review.reviewee_role
        }
      } else {
        info = this.review.reviewer[0]
        if (!info.hasOwnProperty("role")) {
          info["role"] = this.review.reviewer_role
        }
      }
      if (Number(info.ext_ref_id) === this.authUser.user.ext_ref_id && info.role === this.authUser.user.role) {
        switch (info.role) {
          case "hospital_administrator":
            this.$router.push({ name: "HosAbout" })
            break
          case "hcp":
            this.$router.push({ name: "HcpAbout" })
            break
          case "nfp_administrator":
            this.$router.push({ name: "NFPAbout" })
            break
          case "clinic_administrator":
            this.$router.push({ name: "ClinicAbout" })
            break
          case "doctor":
            this.$router.push({ name: "DocUpdates" })
            break
          case "Business":
            break
          default:
            this.$router.push({ name: "DocUpdates" })
            break
        }
      } else {
        let data = { ...info, role: info.role }
        console.log(data, "data in routing card")
        switch (info.role) {
          case "physician":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({
                  ...info,
                  role: "doctor",
                  id: info.id,
                })
            break
          case "doctor":
            console.log("doctor")
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({
                  ...info,
                  role: "doctor",
                  id: info.id,
                })
            break
          case "providers":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : data.ext_ref_id
              ? this.viewEntityProfile({ ...info, role: "doctor" })
              : this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.id,
                })
            break
          case "other":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hcp",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...info, role: "hcp" })
            break
          case "hcp":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hcp",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...info, role: "hcp" })
            break
          case "hcp_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hcp",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...info, role: "hcp" })
          case "hospital":
            info.id
              ? data.my_circles_id
                ? this.viewProfile({
                    ...info,
                    role: "hospital_administrator",
                    id: info.my_circles_id,
                    ext_ref_id: null,
                  })
                : this.viewEntityProfile({ ...info, role: "hospital" })
              : data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.id,
                })
            break
          case "hospital_administrator":
            info.id
              ? data.my_circles_id
                ? this.viewProfile({
                    ...info,
                    role: "hospital_administrator",
                    id: info.my_circles_id,
                    ext_ref_id: null,
                  })
                : this.viewEntityProfile({ ...info, role: "hospital" })
              : data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.id,
                })
            break
          case "clinic":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "clinic",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile(data)
            break
          case "clinic_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "clinic",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...info, role: "clinic" })
            break
          case "nfp":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "nfp",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile(data)
            break
          case "nfp_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "nfp",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...info, role: "nfp" })
            break
          case "Business":
            this.loadingScreen = true
            break
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.reaction-mob {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mob-cont {
  @media screen and (max-width: 900px) {
    flex-direction: column;
    gap: 16px;
  }
}

.str-grp {
  display: flex;
  gap: 8px;
  height: 24px;
  align-items: center;
}

.star-cont {
  display: flex;
  gap: 24px;
  align-items: center;

  @media screen and (max-width: 900px) {
    display: none;
  }
}

.star-cont-mob {
  display: none;

  @media screen and (max-width: 900px) {
    display: flex;
    gap: 24px;
    align-items: center;
    justify-content: space-between;
  }
}

.text-name {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  // margin-left: 16px;
  margin-bottom: 4px;
  text-transform: capitalize;
}

.text-name-2 {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  margin-right: 8px;
}

.text-name1 {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  margin-left: 16px;
  margin-bottom: 4px;
  text-transform: capitalize;
}

.text-day {
  font-weight: 400;
  font-size: 12px;
  color: #94a3b8;
  // margin-left: 16px;
  margin-bottom: 0px;
  flex-wrap: wrap;
  cursor: pointer;
}

.text-reviewed {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  text-transform: none;
}

.text-link {
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}

.review-text {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  margin-left: 8px;
}

.star-container {
  width: 24px;
  height: 24px;
  border-radius: 2px;
}

.mob {
  display: none;

  @media screen and (max-width: 900px) {
    display: flex;
  }
}

.web {
  display: flex;

  @media screen and (max-width: 900px) {
    display: none;
  }
}

.review-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #647490;
  padding-top: 16px;
}

.see-more {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #94a3b8;
  cursor: pointer;
}

.rate-box {
  font-weight: 700;
  font-size: 12px;
  color: #0f1734;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 8px;
  text-align: center;
  text-transform: capitalize;
  display: flex;
  gap: 8px;
  align-items: center;
}

.rate-value {
  font-weight: 700;
  font-size: 12px;
  color: #0f1734;
}

.footer-container {
  display: flex;

  @media only screen and (max-width: 500px) {
    flex-direction: column;
    gap: 24px;
  }
}

.footer-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;

  @media screen and (max-width: 900px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.like-button {
  margin-left: 20px;

  @media only screen and (max-width: 500px) {
    margin-left: 0px;
  }

  cursor: pointer;
}

.mob-visible {
  display: none;

  @media screen and (max-width: 900px) {
    display: flex;
  }
}

.web-visible {
  display: flex;
  align-items: center;

  @media screen and (max-width: 900px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/reviews/MedReviewCard.vue